<script>
export default {
    name: "ViewFile",

    props: {

        patientDocument: Object,
        showModal: Boolean,
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="w-9/12">
      <template v-slot:title>
        <h5 class="font-bold text-base">View Document</h5>
      </template>
      <template v-slot:modal-body>
        <div class="mx-auto">
        <iframe :src="`data:application/pdf;base64,${patientDocument.document}`" height="800" width="1200"></iframe>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs" @click="$emit('closeModal')"><i class="fa fa-times"></i> Close</button>
      </template>
    </tail-modal>
</template>